<template>
    <div v-if="showApp">
        <page-sav-web></page-sav-web>
    </div>
</template>

<script>

import PageSavWeb from "@/projects/sav-web/components/page-home.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PageSavWeb,
    },
};
</script>

<style></style>
